module.exports = __webpack_public_path__ + "media/images/patent/z_5-e0462b00f483c6b91c2051c143b1f91f.png";